import { State } from 'modules';

export const prints = (state: State) => state.blankCheck.prints;
export const printsPage = (state: State) => state.blankCheck.printsPage;
export const allPrintsLoaded = (state: State) =>
  state.blankCheck.allPrintsLoaded;
export const generatePending = (state: State) =>
  state.blankCheck.generatePending;
export const loadPrintsPending = (state: State) =>
  state.blankCheck.loadPrintsPending;
export const loadMorePrintsPending = (state: State) =>
  state.blankCheck.loadMorePrintsPending;
